const BrandMarquee = ({ brandOptions }) => (
  <section className="brand-marquee">
    <div className="marquee-track">
      {[...brandOptions, ...brandOptions].map((b, i) => (
        <span key={i}>
          <span className="marquee-item">{b.name}</span>
          <span className="marquee-sep">•</span>
        </span>
      ))}
    </div>
  </section>
);

export default BrandMarquee;
